__webpack_require__.p = "https://qa-ctrl.nexxen.com/resources/20251204113143/";